import { type NextPage } from "next";
import Link from "next/link";
import NoSSR from "react-no-ssr";

import { Button } from "@moment/ui";

import { isDesktopAppMode } from "~/auth/interop/common";
import { useAuth } from "~/auth/useAuth";
import { useDoLogin } from "~/components/topbar/LoginButton";
import { TopBarDisplay } from "~/components/topbar/TopBar";
import { HOMEPAGE_ROUTE } from "~/strings";

export const Error404Page: NextPage = () => {
	const route = isDesktopAppMode() ? HOMEPAGE_ROUTE : "https://www.moment.dev";
	const { isAuthenticated } = useAuth();
	const [doLogin, loginDisabled] = useDoLogin();

	return (
		<>
			{!isDesktopAppMode() && isAuthenticated && (
				<NoSSR>
					<TopBarDisplay />
				</NoSSR>
			)}
			<div className="flex items-center justify-center min-h-screen bg-primary">
				<div className="text-center text-4xl font-bold border-r border-primary pr-4">
					404
				</div>
				<div className="flex flex-col gap-1 pl-4 text-secondary text-base">
					<div className="text-center text-lg">Page not found</div>
					<div>
						<Link href={route}>← Back home</Link>
					</div>
					<NoSSR>
						{!isAuthenticated && !isDesktopAppMode() && !loginDisabled && (
							<Button onClick={doLogin} className="mt-4">
								← Login
							</Button>
						)}
					</NoSSR>
				</div>
			</div>
		</>
	);
};

export default Error404Page;
